import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { SurveyComposerPage } from '@/features/surveys';

export const Route = createFileRoute('/surveys_/$surveyId/edit')({
  component: SurveyEditRoute,
});

function SurveyEditRoute(): ReactNode {
  const { surveyId } = Route.useParams();
  return (
    <AuthGuard>
      <SurveyComposerPage surveyId={surveyId} />
    </AuthGuard>
  );
}
